import React from "react";
import Table from "rc-table";
import { PriceUpdateRecord } from "../../../types/PricesTypes";
// import { useNavigate } from "react-router-dom";
// import exp from "constants";

interface PricesTableProps {
  data: PriceUpdateRecord[];
  showExpandedView?: boolean;
  onExpandRecord?: (recordId: string) => void;
  expandedRecords?: { [key: string]: any[] };
  detailsLoading?: boolean;
}

const PricesTable: React.FC<PricesTableProps> = ({
  data,
  showExpandedView = false,
  onExpandRecord,
  expandedRecords = {},
  detailsLoading = false,
}) => {
  // const navigate = useNavigate();

  const formatPrice = (price: number) => {
    if (price === undefined || price === null) {
      return "-";
    }
    return `${price} zł`;
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("pl-PL");
  };

  const renderSKUCell = (record: PriceUpdateRecord) => {
    // Expanded view - show all items or limited with expand functionality
    const visibleItems = record.items.slice(0, 6);
    const expanded = expandedRecords[record.id];
    const itemsToShow = expanded || visibleItems;
    // const moreCount = record.items.length - 6;

    return (
      <div className="sku-cell">
        {itemsToShow.map((item, index) => (
          <div key={index} className="sku-item">
            {item.sku}
          </div>
        ))}
        {record.hasMore && onExpandRecord && (
          <button
            className="expand-button"
            onClick={() => onExpandRecord(record.id)}
            disabled={detailsLoading}
          >
            + {record.totalItems - 6} więcej
          </button>
        )}
        {expanded && onExpandRecord && (
          <button
            className="expand-button"
            onClick={() => onExpandRecord(record.id)}
          >
            Zwiń
          </button>
        )}
      </div>
    );
  };

  const renderPriceBeforeCell = (record: PriceUpdateRecord) => {
    const visibleItems = record.items.slice(0, 6);
    const expanded = expandedRecords[record.id];
    const itemsToShow = expanded || visibleItems;

    return (
      <div className="price-cell">
        {itemsToShow.map((item, index) => (
          <div key={index} className="price-item">
            {formatPrice(item?.priceBefore)}
          </div>
        ))}
      </div>
    );
  };

  const renderPriceAfterCell = (record: PriceUpdateRecord) => {
    const visibleItems = record.items.slice(0, 6);
    const expanded = expandedRecords[record.id];
    const itemsToShow = expanded || visibleItems;

    return (
      <div className="price-cell">
        {itemsToShow.map((item, index) => (
          <div key={index} className="price-item">
            {formatPrice(item.priceAfter)}
          </div>
        ))}
      </div>
    );
  };

  const columns = [
    {
      title: "DATA ZMIANY",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (_: any, record: PriceUpdateRecord) => record.createdAt,
    },
    {
      title: "ZAKTUALIZOWANE SKU",
      key: "sku",
      render: (_: any, record: PriceUpdateRecord) => renderSKUCell(record),
    },

    {
      title: "CENA PRZED",
      key: "priceBefore",
      render: (_: any, record: PriceUpdateRecord) =>
        renderPriceBeforeCell(record),
    },
    {
      title: "CENA PO",
      key: "priceAfter",
      render: (_: any, record: PriceUpdateRecord) =>
        renderPriceAfterCell(record),
    },

    {
      title: "UŻYTKOWNIK WPROWADZAJĄCY",
      dataIndex: "userName",
      key: "userName",
    },
  ];

  const mobileColumns = [
    {
      title: "Aktualizacja cen",
      key: "mobile",
      render: (_: any, record: PriceUpdateRecord) => (
        <div className="mobile-record">
          <div className="mobile-record__date">
            {formatDate(record.createdAt)}
          </div>
          <div className="mobile-record__user">
            Użytkownik: {record.userName}
          </div>
          <div className="mobile-record__sku">{renderSKUCell(record)}</div>
        </div>
      ),
    },
  ];

  return (
    <>
      <Table
        rowKey="id"
        className="prices-table desktop-table"
        data={data}
        columns={columns}
        emptyText="Brak danych do wyświetlenia"
      />

      <Table
        rowKey="id"
        className="prices-table mobile-table"
        data={data}
        columns={mobileColumns}
        showHeader={false}
      />
    </>
  );
};

export default PricesTable;
